module.exports = __webpack_public_path__ + "static/wpack/extracted/hand-senda30a72d1dee9347687a6d9770aa19970.svg";